import { useTheme } from "@mui/material/styles";
import {Box, Button, Divider, Grid, Modal, Stack, Typography, useMediaQuery} from "@mui/material";

import AuthWrapper1 from "./AuthWrapper1";
import AuthCardWrapper from "./AuthCardWrapper";
import AuthFooter from "../../../styles/ui-component/cards/AuthFooter";

import Logo from "../../../layout/MainLayout/LogoSection/Logo";
import { useState } from "react";
import ForgotPassword from "../auth-forms/ForgotPassword";
import AuthChangePassword from "../auth-forms/AuthChangePassword";

const ChangePassword = () => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
    const [openModal, setOpenModal] = useState<boolean>(false);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '300px',
        bgcolor: 'background.paper',
        border: '0',
        borderRadius: '20px',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        display="block"
                        color="textSecondary"
                        variant="caption"
                        fontSize="16px"
                        align="center"
                    >
                        Request Password Reset
                    </Typography>
                    <ForgotPassword setOpenModal={setOpenModal} />
                </Box>
            </Modal>
            <AuthWrapper1>
                <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: "100vh" }}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "calc(100vh - 68px)" }}>
                            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                <AuthCardWrapper>
                                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                                        <Grid item sx={{ mb: 3 }}>
                                            <Logo />
                                        </Grid>
                                            <Grid item xs={12}>
                                                <Grid
                                                    container
                                                    direction={matchDownSM ? "column-reverse" : "row"}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                                                    <Grid item>
                                                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                            <Typography
                                                                variant="caption"
                                                                fontSize="16px"
                                                                textAlign={matchDownSM ? "center" : "inherit"}
                                                            >
                                                                Enter your credentials to continue
                                                            </Typography>
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <AuthChangePassword setOpenModal={setOpenModal} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                            <Grid item container direction="column" alignItems="center" xs={12}>
                                                <Button
                                                    onClick={handleOpenModal}
                                                >
                                                    Resend Code?
                                                </Button>
                                            </Grid>
                                    </Grid>
                                </AuthCardWrapper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                        <AuthFooter />
                    </Grid>
                </Grid>
            </AuthWrapper1>
        </>
    );
};

export default ChangePassword;
